$('.shopify-currency-form select').on('change', function () {
  $(this).parents('form').submit();
});
